export const state = {
  deadsales: [],
  dead_sale_items: [
    {
      product_id: "",
      truck_id: "",
      product_measurement: "",
      balance_stock: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remark: ""
    }
  ]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/deadsales/state.js